import {
  titleUI,
  checkboxGroupUI,
  checkboxGroupSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { isRelationshipToVeteran } from '../../../utils/helpers';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['benefit-type-title']),
    claims: {
      ...checkboxGroupUI({
        required: true,
        labels: {
          dic: {
            title: content['benefit-type-dic-title'],
            description: content['benefit-type-dic-description'],
          },
          survivorsPension: {
            title: content['benefit-type-survivors-title'],
            description: content['benefit-type-survivors-description'],
          },
          accruedBenefits: {
            title: content['benefit-type-accrued-title'],
            description: content['benefit-type-accrued-description'],
          },
        },
      }),
      'ui:options': {
        tile: true,
        hint: content['benefit-type-hint'],
        updateSchema: formData => {
          let title = content['benefit-type-updated-title'];
          if (isRelationshipToVeteran(formData) === 'custodian') {
            title = content['benefit-type-custodian-title'];
          }
          return {
            title,
          };
        },
      },
    },
  },
  schema: {
    type: 'object',
    required: [],
    properties: {
      claims: checkboxGroupSchema([
        'dic',
        'survivorsPension',
        'accruedBenefits',
      ]),
    },
  },
};
